import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesComponent } from './pages.component';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { GradeComponent } from './grade/grade.component';
import { ViewGradeComponent } from './grade/view-grade/view-grade.component';
import { InstituteComponent } from './institute/institute.component';
import { ParentComponent } from './parent/parent.component';
import { ViewParentComponent } from './parent/view-parent/view-parent.component';
import { StudentComponent } from './student/student.component';
import { ViewStudentComponent } from './student/view-student/view-student.component';
import { SubjectCourseComponent } from './subject-course/subject-course.component';
import { TutorComponent } from './tutor/tutor.component';
import { ViewTutorComponent } from './tutor/view-tutor/view-tutor.component';
import { SidebarModule } from '../sidebar/sidebar.module';
import { FooterModule } from '../shared/footer/footer.module';
import { NavbarModule } from '../shared/navbar/navbar.module';
import { ReportsComponent } from './reports/reports.component';
import { FreeResourceComponent } from './free-resource/free-resource.component';
import { PackageComponent } from './package/package.component';
import { PromoCodeComponent } from './promo-code/promo-code.component';
const arChildRoutes = [
  {
    path:'dashboard',
    component:DashboardComponent
  },
  {
    path:'student',
    component:StudentComponent
  },
  {
    path:'parent',
    component:ParentComponent
  },
   {
    path:'tutor',
    component:TutorComponent
  },
  {
    path:'view-student/:id',
    component:ViewStudentComponent
  },
  {
    path:'view-parent/:id',
    component:ViewParentComponent
  },
  {
    path:'view-tutor/:id',
    component:ViewTutorComponent
  },
  {
    path:'institute',
    component:InstituteComponent
  },
  {
    path:'subject',
    component:SubjectCourseComponent
  },
  {
    path:"grade",
    component:GradeComponent
  },
  {
    path:"view-grade",
    component:ViewGradeComponent
  },
  {
    path:"report",
    component:ReportsComponent
  },
  {
    path:"free-resource",
    component:FreeResourceComponent
  },
  {
    path:"package",
    component:PackageComponent
  },
  {
    path:"promo",
    component:PromoCodeComponent
  }
];

const routes: Routes = [
  {
      'path': '',
      'component': PagesComponent,
      'children': arChildRoutes
  }
];
@NgModule({
  declarations: [PagesComponent],
  imports: [
    CommonModule,
    NavbarModule,
    RouterModule.forChild(routes),
    SidebarModule,
    FooterModule,

  ]
})
export class PagesModule { }
